import { TagTitleSection } from "../elements/TagTitleSection"
import "../styles/sections/ourservices.styles.css"
import { useRef, useState, useEffect } from "react"
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa6";
import { fetchGetData } from "../../lib/fetchGetData";
import { Link } from "react-router-dom";

/*const ServicesData = [
    {
        title: "Projetos",
        description: "Projetos realizados de forma enxuta e direta para uma melhor disposiçáo do imóver e sistemas. Realizamos projetos Arquitetônicos, Estruturais, Elétricos, Hidráulicos, Incêndio e executivos.",
        link: "/google.com",
        img: project
    }, {
        title: "Projetos",
        description: "Projetos realizados de forma enxuta e direta para uma melhor disposiçáo do imóver e sistemas. Realizamos projetos Arquitetônicos, Estruturais, Elétricos, Hidráulicos, Incêndio e executivos.",
        link: "/google.com",
        img: project
    }, {
        title: "Projetos",
        description: "Projetos realizados de forma enxuta e direta para uma melhor disposiçáo do imóver e sistemas. Realizamos projetos Arquitetônicos, Estruturais, Elétricos, Hidráulicos, Incêndio e executivos.",
        link: "/google.com",
        img: project
    }, {
        title: "Projetos",
        description: "Projetos realizados de forma enxuta e direta para uma melhor disposiçáo do imóver e sistemas. Realizamos projetos Arquitetônicos, Estruturais, Elétricos, Hidráulicos, Incêndio e executivos.",
        link: "/google.com",
        img: project
    }, {
        title: "Projetos",
        description: "Projetos realizados de forma enxuta e direta para uma melhor disposiçáo do imóver e sistemas. Realizamos projetos Arquitetônicos, Estruturais, Elétricos, Hidráulicos, Incêndio e executivos.",
        link: "/google.com",
        img: project
    } , {
        title: "Projetos",
        description: "Projetos realizados de forma enxuta e direta para uma melhor disposiçáo do imóver e sistemas. Realizamos projetos Arquitetônicos, Estruturais, Elétricos, Hidráulicos, Incêndio e executivos.",
        link: "/google.com",
        img: project
    }  , {
        title: "Projetos",
        description: "Projetos realizados de forma enxuta e direta para uma melhor disposiçáo do imóver e sistemas. Realizamos projetos Arquitetônicos, Estruturais, Elétricos, Hidráulicos, Incêndio e executivos.",
        link: "/google.com",
        img: project
    } , {
        title: "Projetos",
        description: "Projetos realizados de forma enxuta e direta para uma melhor disposiçáo do imóver e sistemas. Realizamos projetos Arquitetônicos, Estruturais, Elétricos, Hidráulicos, Incêndio e executivos.",
        link: "/google.com",
        img: project
    }
]*/

export const OurServices = () => {
    const containerRef = useRef(null)
    const [containerWidth, setContainerWidth] = useState(0)
    const [servicesData, setServicesData] = useState([])

    useEffect(() => {
        async function fetchData() {
            let data = await fetchGetData("services")
            setServicesData(data)
        }
        fetchData()
    }, [])

    function handleContainerResize() {
        const containerDimensions = containerRef.current.getBoundingClientRect()
        setContainerWidth(containerDimensions.width)
    }

    function handleNextClick() {
        containerRef.current.scrollLeft += containerWidth / 2
    }

    function handlePrevClick() {
        containerRef.current.scrollLeft -= containerWidth / 2
    }

    const RenderServices = () => {
        const RenderService = (props) => {
            let { title, description, img, link } = props
            return (
                <div className="service-box">
                    <img src={img} alt="Imagem de Projeto" width={300} height={200} />
                    <div className="service-texts">
                        <p className="title-service">{title}</p>
                        <span></span>
                        <p className="descrip-service">{description}</p>
                    </div>
                    <Link to={`/nossos-servicos/${link}`}>Saiba Mais</Link>
                </div>
            )
        }

        return (
            servicesData.map((service) => (
                <RenderService
                    key={service.id}
                    title={service.name}
                    description={service.shortDescrip}
                    link={service.link}
                    img={service.imgHome}
                />
            ))
        )
    }

    return (
        <section id="our-services" className="section-ourserives">
            <TagTitleSection title="Nossos Serviços" />
            <div className="our-services">
                <button
                    className='Navigation-btn Navigation-btn-left'
                    onClick={handlePrevClick}
                    aria-label="Retroceta a vizualização do serviços"
                >
                    <FaArrowLeft />
                </button>
                <button
                    className='Navigation-btn Navigation-btn-right'
                    onClick={handleNextClick}
                    aria-label="Avance a vizualização do serviços"
                >
                    <FaArrowRight />
                </button>
                <div
                    className="container-services"
                    ref={containerRef}
                    onLoad={handleContainerResize}
                    onResize={handleContainerResize}

                >
                    <RenderServices />
                </div>
            </div>
        </section>
    )
}